define('ko/customisedKnockout',[
    'knockout',
    'ko/fn/mod',
    'ko/customBinding/clickPromise',
    'ko/customBinding/define',
    'ko/customBinding/form',
    'ko/customBinding/hook',
    'ko/customBinding/inputField',
    'ko/customBinding/validationClasses',
    'ko/customBinding/ripple',
    'ko/filters/mathFilters'
], function(ko) {

    // Enable ko.punches filter syntax for the style binding
    ko.punches.namespacedBinding.setDefaultBindingPreprocessor('style', ko.punches.textFilter.preprocessor);

    return ko;
});

